module.exports = "/assets/023223b59f742c10728ad7df2ce218d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/supplier/assets/logos/travelodge.png
// module id = 611
// module chunks = 0